import React from 'react';
import './Parceiros.scss'; 

function Parceiros() {
  return (
    <div className="parceiros-container">
        <div className="parceiro-item">
            <img src='/img/parceiros/logo_guarana_antarctica.png' alt='Guaraná Antarctica | Ambev'/>
        </div>
        <div className="parceiro-item">
            <img src='/img/parceiros/logo_saipos.png' alt='Saipos'/>
        </div>
        <div className="parceiro-item">
            <img src='/img/parceiros/logo_dcx.png' alt='DCX Embalagens'/>
        </div>
        <div className="parceiro-item">
            <img src='/img/parceiros/logo_sadia_new.png' alt='Sadia'/>
        </div>
    </div>
  );
}

export default Parceiros;
